import { VisitList } from "components/job/visit/VisitList";
import { ServiceJob } from "operations/schema/schema";
import { FC } from "react";

type VisitsTabProps = {
  visits: ServiceJob[];
};
export const VisitsTab: FC<VisitsTabProps> = ({ visits }) => {
  return (
    <>
      <VisitList visits={visits} />
    </>
  );
};
